// These are active-table UI caches, not saved invoice/KOT history.
export const activeTableCacheKeys = ['billItems', 'kotPrints', 'selectedTableNo'];

export function moveActiveTableEntries(entries, fromTable, toTable) {
  if (!Array.isArray(entries) || fromTable === toTable) return entries;
  const moving = entries.filter(entry => entry?.tableNo === fromTable);
  if (!moving.length) return entries;
  return [
    ...entries.filter(entry => entry?.tableNo !== fromTable && entry?.tableNo !== toTable),
    ...moving.map(entry => ({ ...entry, tableNo: toTable })),
  ];
}

export function moveActiveTableCaches(storage, fromTable, toTable) {
  let failed = false;
  for (const key of activeTableCacheKeys) {
    try {
      const raw = storage.getItem(key);
      if (raw) storage.setItem(key, JSON.stringify(moveActiveTableEntries(JSON.parse(raw), fromTable, toTable)));
    } catch {
      // A storage error must never make a committed server transfer look failed.
      failed = true;
    }
  }
  return !failed;
}
